import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

class BillService {
  allTypeBills(typeBill, isGenerated, isDeleted) {
    return api.get(
      UtilsUrl.billURL() +
        "/getTypeBillActiveDeleteTypeBill/" +
        typeBill +
        "/" +
        isGenerated +
        "/" +
        isDeleted
    );
  }
  allTypeBillsForAdd(isGenerated, isDeleted, isIncome) {
    return api.get(
      UtilsUrl.billURL() +
        "/getTypeBillActiveDeleteIncome/" +
        isGenerated +
        "/" +
        isDeleted +
        "/" +
        isIncome
    );
  }

  getTypeBillById(idTypeBill) {
    return api.get(UtilsUrl.billURL() + "/getTypeBillById/" + idTypeBill);
  }

  getBillAndExrats(idBill) {
    return api.get(UtilsUrl.billURL() + "/getBillEndExtratID/" + idBill);
  }

  getBillAndExratsRefFacture(refFacture, typeFacture) {
    return api.get(
      UtilsUrl.billURL() +
        "/getBillEndExtratRefFactureTypeBill/" +
        refFacture +
        "/" +
        typeFacture
    );
  }

  allBillsTypeBill(typeBill, isActive, isDeleted) {
    return api.get(
      UtilsUrl.billURL() +
        "/getBillsGeneratedDeleteTypeBill/" +
        typeBill +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  numberNotPayedBill(typeBill, payed, isActive, isDeleted) {
    // let idUser = currentUserId();
    return api.get(
      UtilsUrl.billURL() +
        "/getNumberBillsPayedGeneratedDeleteTypeBill/" +
        typeBill +
        "/" +
        payed +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
  allBillsPayed(idSociete, isIncome, payed, isActive, isDeleted) {
    let idUser = currentUserId();
    return api.get(
      UtilsUrl.billURL() +
        "/listBillPayedState/" +
        idSociete +
        "/" +
        idUser +
        "/" +
        isIncome +
        "/" +
        payed +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  amountTTAllBillsPayed(idSociete, isIncome, payed, isActive, isDeleted) {
    let idUser = currentUserId();
    return api.get(
      UtilsUrl.billURL() +
        "/amountTTAllBillsPayed/" +
        idSociete +
        "/" +
        idUser +
        "/" +
        isIncome +
        "/" +
        payed +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
  allBillsType(idTypeBill, isActive, isDeleted) {
    return api.get(
      UtilsUrl.billURL() +
        "/getBillsTypeGeneratedDelete/" +
        idTypeBill +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
  addTypeBill(bill) {
    return api.post(UtilsUrl.billURL() + "/addTypeBill", bill);
  }

  addBill(bill) {
    return api.post(UtilsUrl.billURL() + "/addBill", bill);
  }

  addBillBC(bill) {
    return api.post(UtilsUrl.billURL() + "/addBillBC", bill);
  }

  addExtratBill(extrat) {
    return api.post(UtilsUrl.billURL() + "/addExtractBill", extrat);
  }

  payerBill(idBill, payed) {
    return api.get(UtilsUrl.billURL() + "/payerBill/" + idBill + "/" + payed);
  }
  supprimerBill(idBill) {
    return api.get(UtilsUrl.billURL() + "/deleteBill/" + idBill);
  }
  confirmFacture(idBill, generete) {
    return api.get(
      UtilsUrl.billURL() + "/confirmBill/" + idBill + "/" + generete
    );
  }
  getCheque(idBill) {
    return api.get(UtilsUrl.billURL() + "/getCheque/" + idBill);
  }
  getEcheances(idBill) {
    return api.get(UtilsUrl.billURL() + "/getEcheances/" + idBill);
  }
  payerFactureEspece(payement) {
    return api.post(UtilsUrl.billURL() + "/payerFactureEspece", payement);
  }
  payerFactureCheque(idBill, payed) {
    return api.get(
      UtilsUrl.billURL() + "/payerFactureCheque/" + idBill + "/" + payed
    );
  }
  getRetenuSource() {
    return api.get(UtilsUrl.retenuURL() + "/getRetenuSource");
  }

  fileRetenuSource(idBill) {
    return api.get(UtilsUrl.retenuURL() + "/genererRetenu/" + idBill);
  }

  validateBill(idBill) {
    return api.get(UtilsUrl.billURL() + "/validateBill/" + idBill);
  }
  deleteBillDraft(idBill) {
    return api.get(UtilsUrl.billURL() + "/deleteBillDraft/" + idBill);
  }

  // getMaxAmountBC(idBC){
  //   return api.get(billURL() + "/getMaxAmountBC/" + idBC );
  // }

  payerChequeAvanceBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerChequeAvanceBill", payement);
  }

  payerEnLigneAvanceBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerEnLigneAvanceBill", payement);
  }

  payerEspeceAvanceBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerEspeceAvanceBill", payement);
  }

  payerChequeTotalBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerChequeTotalBill", payement);
  }

  payerEnLigneTotalBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerEnLigneTotalBill", payement);
  }

  payerEspeceTotalBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerEspeceTotalBill", payement);
  }
  payerVirementTotalBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerVirementTotalBill", payement);
  }
  payerVirementAvanceBill(payement) {
    return api.post(UtilsUrl.billURL() + "/payerVirementAvanceBill", payement);
  }

  listAvancePayementBill(idBill) {
    return api.get(UtilsUrl.billURL() + "/getAvancesPayementBill/" + idBill);
  }

  listTotalPayementBill(idBill) {
    return api.get(UtilsUrl.billURL() + "/getTotalPayementBill/" + idBill);
  }

  //by me

  getFacturesByFilterForPayementTask = (
    isPayedForBackend,
    idSupplier,
    month,
    year
  ) => {
    let currentUser = currentUserId();

    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }

    return api.get(
      `/retail/document/getFacturesByFilterForPayementTask/${currentUser}/${isPayedForBackend}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}`
    );
  };

  getBonDeCommandeByFilterForPayementTask = (idSupplier, month, year) => {
    let currentUser = currentUserId();

    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }

    return api.get(
      `/retail/document/getBonDeCommandeByFilterForPayementTask/${currentUser}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}`
    );
  };

  getAllDocumentsByFilterForPayementTask = (
    isPayedForBackend,
    idSupplier,
    month,
    year,
    documentType
  ) => {
    let currentUser = currentUserId();
    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";
    let isPayed;

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }
    if (isPayedForBackend === "any") {
      isPayed = -1;
    } else {
      isPayed = parseInt(isPayedForBackend);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "Tous"&& year !== "00") {
      yearForBackend = year;
    }

    return api.get(
      `/retail/document/getAllDocumentsByFilterForPayementTask/${currentUser}/${isPayed}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}/${documentType}`
    );
  };
}

export default new BillService();
